function valueOr<T>(value: T | null | undefined, defaultValue: T): T {
  return value ?? defaultValue;
}

/**
 * This may seem like a silly function, but we have to do value || 0 in a lot of places, and we keep tripping over operator precedence. Consider that
 *
 * ```
 * (acc) => acc + record.estimate || 0
 * ```
 *
 * will do the wrong thing, because the `||` operator has lower precedence than the `+` operator. Instead:
 *
 * ```
 * (acc) => acc + orZero(record.estimate)
 * ```
 *
 * Always correct
 */
export function orZero(value: number | null | undefined) {
  return valueOr(value, 0);
}
